import styledComponent from 'styled-components';

export const Row = styledComponent.tr`
  display: flex;
  justify-content: 'row';
  marginbottom: '6px';
`;
